/**
 * **デュエルの開始**（Issue #645）。疑似イベント `start`（`editorPorts/duelStart.js`。core は MSG_START を出さない）。
 * 分岐は無い。事実: `firstPlayer`（先攻）/ `startLp`（開始時の LP）
 */
export default Object.freeze({
  event: 'start',
  label: 'デュエルの開始',
  variants: Object.freeze([]),
  classify({ payload }) {
    if (!payload) return null;
    const d = payload.data ?? {};
    const firstPlayer = d.first_player === 1 ? 1 : 0;
    const startLp = Number.isFinite(d.lp?.[0]) ? d.lp[0] : null;
    return { ...payload, firstPlayer, startLp };
  },
});
